module.exports = __webpack_public_path__ + "media/images/fig_market-8567a8c104e4f3ca2309aca4d0254bc9.png";